import React from 'react'
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import '../../../i18n/i18n'
import { useTranslation } from 'react-i18next'
import {
  CGV,
  CustomerAddress,
  Footer,
  Header,
  Payment,
  style,
  Subject,
  TableBody,
  TableHead,
  TableTotal
} from '../../document/DocumentPDF'
import { baseDocument } from '../../../utils/constants/misc'

const QuotePDF = ({ quote_param: quote, company_param: company, logo_param: img, settings }) => {
  const customer = quote.customer
  const styles = StyleSheet.create(style)
  const { t } = useTranslation()

  const References = () => {
    if (quote) {
      const date = new Date(quote.quote_date)
      const dateVal = new Date(quote.validity_date)
      const dateConv = t('dates.localisedDate', { date: date })

      const dateValConv = t('dates.localisedDate', { date: dateVal })
      return (
        <>
          <View style={styles.rightContainer}>
            <Text style={styles.boldWithSpace}>Référence devis</Text>
            <Text style={styles.address}>{quote.quote_number}</Text>
          </View>
          <View style={styles.rightContainer}>
            <Text style={styles.bold}>Date de création {dateConv}</Text>
          </View>
          <View style={styles.rightContainerNoSpaceBottom}>
            <Text style={styles.bold}>{`Valable jusqu'au ${dateValConv}`}</Text>
          </View>
        </>
      )
    }
  }

  const QuotePayment = () => (
    <View style={{ marginTop: 20 }}>
      <Text style={styles.conditions}>Merci de nous retourner ce devis signé avec la mention "Bon pour accord".</Text>
    </View>
  )

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header img={img} styles={styles} title={'DEVIS'} />
          <References />
        </View>
        <View>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <Subject styles={styles} document={quote} />
        </View>
        <View fixed>
          <TableHead styles={styles} headers={baseDocument} />
        </View>
        <View style={{ flex: 0.8, marginBottom: '5px', paddingBottom: '10px' }}>
          <TableBody headers={baseDocument} lines={quote.lines} styles={styles} />
          <TableTotal total={quote.total_amount_net} styles={styles} company={company} />
          <Payment customer={customer} settings={settings} styles={styles} />
          <QuotePayment />
        </View>
        <Footer company={company} styles={styles} />
      </Page>
      <CGV customer={customer} company={company} styles={styles} />
    </Document>
  )
}

export default React.memo(QuotePDF)
